<mat-card>
    <div class="card-header row">
        <div class="col-8">
            <h2>Deal Type</h2>
        </div>
        <div class="col-4 edit">
            <button mat-button (click)="goToStep(createDealSteps.dealType)">Edit</button>
        </div>
        <hr />
    </div>
    <app-dealer-form [dealerFormProperties]="dealerFormProperties" [disabledInputs]="['dealerDealNumber']"> </app-dealer-form>

    <div *ngIf="templateGroupSelection"></div>
</mat-card>

<mat-card>
    <div class="card-header row">
        <div class="col-8">
            <h2>Buyer</h2>
        </div>
        <div class="col-4 edit">
            <button mat-button (click)="goToStep(createDealSteps.details)">Edit</button>
        </div>
        <hr />
    </div>

    <app-customer-form-component [customerFormProperties]="buyerForm" [disabledInputs]="['firstName', 'lastName', 'email', 'phone']">
    </app-customer-form-component>
</mat-card>

<ng-container *ngIf="coBuyerFormProperties">
    <mat-card>
        <div class="card-header row">
            <div class="col-8">
                <h2>Co-Buyer</h2>
            </div>
            <div class="col-4 edit">
                <button mat-button (click)="goToStep(createDealSteps.details)">Edit</button>
            </div>
            <hr />
        </div>
        <app-customer-form-component [customerFormProperties]="coBuyerForm" [disabledInputs]="['firstName', 'lastName', 'email', 'phone']">
        </app-customer-form-component>
    </mat-card>
</ng-container>

<mat-card *ngIf="tradeInVehicle">
    <div class="card-header row">
        <div class="col-8">
            <h2>Trade-In Vehicle</h2>
        </div>
        <div class="col-4 edit">
            <button mat-button (click)="goToStep(createDealSteps.details)">Edit</button>
        </div>
        <hr />
        <div class="trade-in-vehicle-info row">
            <div class="col-6">
                <p *ngIf="tradeInVehicle.vin"><b>VIN:</b> {{ tradeInVehicle.vin }}</p>
                <p *ngIf="tradeInVehicle.stockNumber"><b>Stock:</b> {{ tradeInVehicle.stockNumber }}</p>
                <p *ngIf="tradeInVehicle.vehicleExt?.priceInternet"><b>Price:</b> ${{ tradeInVehicle.vehicleExt.priceInternet }}</p>
                <p *ngIf="tradeInVehicle.payoff"><b>Payoff Amount:</b> ${{ tradeInVehicle.payoff }}</p>
                <p *ngIf="tradeInVehicle.year || tradeInVehicle.make || tradeInVehicle.model">
                    <b>Vehicle:</b> {{ tradeInVehicle.year }} {{ tradeInVehicle.make }} {{ tradeInVehicle.model }}
                </p>
                <p *ngIf="tradeInVehicle.trim"><b>Trim:</b> {{ tradeInVehicle.trim }}</p>
            </div>
            <div class="col-6">
                <p *ngIf="tradeInVehicle.vehicleExt?.exteriorColor"><b>Exterior Color:</b> {{ tradeInVehicle.vehicleExt.exteriorColor }}</p>
                <p *ngIf="tradeInVehicle.vehicleExt?.interiorColor"><b>Interior Color:</b> {{ tradeInVehicle.vehicleExt.interiorColor }}</p>
                <p *ngIf="tradeInVehicle.bodyStyle"><b>Body Style:</b> {{ tradeInVehicle.bodyStyle }}</p>
                <!--<p *ngIf="tradeInVehicle.vehicleExt?.bodyType"><b>Body Type:</b> {{tradeInVehicle.vehicleExt.bodyType}}</p>-->
            </div>
        </div>
    </div>
</mat-card>

<mat-card>
    <div class="card-header row">
        <div class="col-8">
            <h2>Vehicle</h2>
        </div>
        <div class="col-4 edit">
            <button mat-button (click)="goToStep(createDealSteps.details)">Edit</button>
        </div>
        <hr />
    </div>
    <app-vehicle [vehicle]="vehicleProperties"></app-vehicle>
</mat-card>
